<div id="enrollment-agreement">
  <div class="page1">

    <p class="text-center mb-1"><img style="max-width:250px;" src="assets/images/AMDCBlackHorizontalJPG.jpg" /></p>
    <h3 class="text-center fw-bold mb-4">STUDENT ENROLMENT AGREEMENT</h3>

    <!-- Student Information -->
    <div class="row mb-2">
      <div class="col-12">
        <div class="d-flex border-bottom pb-1 mb-2">
          <span class="fw-bold me-2" style="white-space:nowrap;">STUDENT</span>
          <div class="d-flex flex-grow-1 gap-3">
            <div class="flex-grow-1">
              <small class="text-muted d-block" style="font-size:0.7rem;">First Name</small>
              <span>{{ primaryContact?.field_first_name || entityData?.['field_student']?.['title']?.split(' ')[0] || '' }}</span>
            </div>
            <div class="flex-grow-1">
              <small class="text-muted d-block" style="font-size:0.7rem;">Last Name</small>
              <span>{{ primaryContact?.field_last_name || entityData?.['field_student']?.['title']?.split(' ').slice(1).join(' ') || '' }}</span>
            </div>
            <div class="flex-grow-1">
              <small class="text-muted d-block" style="font-size:0.7rem;">Street Address</small>
              <span>{{ primaryContact?.field_address?.address_line1 || '' }}</span>
            </div>
            <div>
              <small class="text-muted d-block" style="font-size:0.7rem;">City</small>
              <span>{{ primaryContact?.field_address?.locality || '' }}</span>
            </div>
          </div>
        </div>

        <div class="d-flex gap-3 border-bottom pb-1 mb-3">
          <div>
            <span class="fw-bold me-1">STATE</span>
            <span>{{ primaryContact?.field_address?.administrative_area || '' }}</span>
          </div>
          <div>
            <span class="fw-bold me-1">POSTCODE</span>
            <span>{{ primaryContact?.field_address?.postal_code || '' }}</span>
          </div>
          <div class="flex-grow-1">
            <span class="fw-bold me-1">PHONE</span>
            <span>{{ primaryContact?.field_cell_phone || '' }}</span>
          </div>
          <div class="flex-grow-1">
            <span class="fw-bold me-1">EMAIL</span>
            <span>{{ primaryContact?.field_email || '' }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Type of Enrolment + Lesson Table -->
    <div class="row mb-3">
      <div class="col-3">
        <p class="fw-bold mb-2">TYPE OF ENROLMENT</p>
        <div class="d-flex align-items-center mb-1">
          <span class="border d-inline-block me-2" style="width:16px;height:16px;" [style.background]="enrollmentTypeState.original ? '#000' : '#fff'"></span>
          <span>ORIGINAL</span>
        </div>
        <div class="d-flex align-items-center mb-1">
          <span class="border d-inline-block me-2" style="width:16px;height:16px;" [style.background]="enrollmentTypeState.extension ? '#000' : '#fff'"></span>
          <span>EXTENSION</span>
        </div>
        <div class="d-flex align-items-center mb-1">
          <span class="border d-inline-block me-2" style="width:16px;height:16px;" [style.background]="enrollmentTypeState.renewal ? '#000' : '#fff'"></span>
          <span>RENEWAL</span>
        </div>
        <div class="d-flex align-items-center mb-1">
          <span class="border d-inline-block me-2" style="width:16px;height:16px;" [style.background]="enrollmentTypeState.service ? '#000' : '#fff'"></span>
          <span>SERVICE</span>
        </div>
      </div>
      <div class="col-9">
        <p class="mb-2">The Student agrees to purchase, and the owner of the Arthur Murray&reg; Franchised Dance Studio (the "Studio") agrees to provide the following course of dance instruction and/or services on the following terms and conditions:</p>

        <table class="table table-bordered text-center small mb-1">
          <tr>
            <td class="fw-bold">PRIVATE LESSONS</td>
            <td class="fw-bold">GROUPS &amp; PARTIES</td>
            <td class="fw-bold">TUITION</td>
            <td class="fw-bold">DISCOUNT</td>
            <td class="fw-bold">BALANCE DUE</td>
          </tr>
          <tr>
            <td>{{ entityData?.['field_enrollment_lesson_count'] || '' }}</td>
            <td></td>
            <td>${{ getOriginalPackageCost() | number:'1.2-2' }}</td>
            <td>${{ getDiscount() | number:'1.2-2' }}</td>
            <td>${{ calculateTotalTuition() | number:'1.2-2' }}</td>
          </tr>
        </table>

        <p class="fw-bold text-center small mb-0">LESSONS ARE 45 MINUTES WHICH INCLUDES TRANSITION TIME BETWEEN LESSONS</p>
      </div>
    </div>

    <!-- Miscellaneous Services -->
    <table class="table table-bordered small mb-3">
      <tr>
        <td class="fw-bold" style="width:15%">
          <span class="d-block">THIS PART</span>
          <span class="d-block">IS NOT</span>
          <span>APPLICABLE</span>
          <span class="border d-inline-block ms-2" style="width:16px;height:16px;"></span>
        </td>
        <td class="fw-bold text-center">TYPE OF MISCELLANEOUS SERVICE(S)</td>
        <td class="fw-bold text-center" style="width:20%">TUITION OR COST</td>
      </tr>
    </table>

    <!-- Payment Terms -->
    <p>The Student agrees to make an initial tuition payment of ${{ initialPaymentAmount !== null ? (initialPaymentAmount | number:'1.2-2') : '________' }} today.</p>
    <p>Following the initial tuition payment, the student agrees to arrange any remaining tuition balance as follows:</p>

    <table class="table table-bordered table-sm text-center small mb-2" *ngIf="balancePaymentRows.length; else blankBalanceLines">
      <tr>
        <th>Payment #</th>
        <th>Amount</th>
        <th>Due Date</th>
      </tr>
      <tr *ngFor="let payment of balancePaymentRows; let i = index">
        <td>{{ i + 1 }}</td>
        <td>${{ payment.amount | number:'1.2-2' }}</td>
        <td>{{ payment.date ? (payment.date | date) : '' }}</td>
      </tr>
    </table>

    <ng-template #blankBalanceLines>
      <div class="mb-2" style="min-height:60px;">
        <div class="border-bottom mb-2" style="height:1.5rem;"></div>
        <div class="border-bottom mb-2" style="height:1.5rem;"></div>
        <div class="border-bottom" style="height:1.5rem;"></div>
      </div>
    </ng-template>

    <p>The course shall be completed by <span class="border-bottom px-4">{{ entityData?.['field_expiration_date'] | date }}</span> the "term").</p>

    <p>The studio agrees to give the above course of in accordance with the Arthur Murray methods and steps and makes its facilities and personnel available to the student for this purpose. GST is included in the total tuition.</p>

    <!-- Terms and Conditions -->
    <div class="border p-2 small mb-3">
      <p class="mb-1 small fst-italic">It is further agreed and understood by the student and the studio as follows:</p>
      <p class="fw-bold mb-1">Lessons Enrolments (Original, Extension &amp; Renewal):</p>
      <ol class="mb-2" style="font-size:0.85rem;">
        <li>All lessons will be scheduled for specific times within the term.</li>
        <li>If the student wishes to cancel or change any appointment for instruction he or she must notify the studio at least <strong><u>6 hours</u></strong> in advance of the appointment time. If this notification is not provided the student will be deemed to have undertaken that lesson and will be charged for the course as if the lesson had been provided.</li>
        <li>The studio reserves the right to end the agreement at any time and give the student a refund for any untaught lessons.</li>
        <li>This agreement is made by the student with the studio, and does not directly or indirectly constitute an agreement with or any obligation with Arthur Murray Inc.</li>
        <li>The studio will provide the services of a qualified instructor but the studio has the right to change the instructor at anytime.</li>
        <li>This agreement contains all the terms of the agreement between the studio and the student.</li>
        <li>The student has entered into this agreement freely and voluntarily and without reliance upon any oral, written or implied representation.</li>
        <li>Should the student want a refund, a fee of <strong><u>$15 per untaught lesson</u></strong> will be charged to cover associated franchise costs.</li>
      </ol>
      <p class="fw-bold mb-1">Service Enrolments (Special Events &amp; Services):</p>
      <p class="mb-0 small">Every Special Event has its own Policy which is provided to a student. This agreement should be read in conjunction with the Policy signed by both parties.</p>
    </div>

    <!-- Studio Info + Signatures -->
    <div class="row">
      <div class="col-6">
        <p class="mb-0">{{ this.studioInformationConfig?.field_studio_address?.[0]?.organization || '' }}</p>
        <p class="fw-bold mb-0">{{ this.studioInformationConfig?.field_studio_display_name?.[0]?.value || '' }}</p>
        <p class="mb-0" *ngIf="this.studioInformationConfig?.field_studio_abn?.[0]?.value">ABN {{ this.studioInformationConfig?.field_studio_abn?.[0]?.value }}</p>
        <p class="mb-0">
          {{ this.studioInformationConfig?.field_studio_address?.[0]?.address_line1 }},
        </p>
        <p class="mb-0">
          {{ this.studioInformationConfig?.field_studio_address?.[0]?.locality }}
          {{ this.studioInformationConfig?.field_studio_address?.[0]?.administrative_area }}
          {{ this.studioInformationConfig?.field_studio_address?.[0]?.postal_code }}
        </p>
        <p class="mb-0">ph. {{ this.studioInformationConfig?.field_studio_phone_number?.[0]?.value }}</p>
        <p class="fw-bold mb-0">Franchisee:
          {{ this.studioInformationConfig?.field_studio_address?.[0]?.given_name }}
          {{ this.studioInformationConfig?.field_studio_address?.[0]?.family_name }}
        </p>
      </div>
      <div class="col-6" *ngIf="displaySigned">
        <div class="mb-3">
          <p class="fw-bold mb-0">SIGNED:</p>
          <div class="border-bottom" style="height:30px;">
            <img *ngIf="displaySignatures && (_enrollmentEntityData?.['field_signature']?.[0]?.['url'] || entityData?.field_signature?.url)"
                 class="img-fluid" style="max-height:28px;"
                 [src]="_enrollmentEntityData?.['field_signature']?.[0]?.['url'] || entityData?.field_signature?.url" />
          </div>
          <small class="text-muted">Student's signature</small>
        </div>
        <div class="mb-3">
          <p class="fw-bold mb-0">SIGNED:</p>
          <div class="border-bottom" style="height:30px;">
            <img *ngIf="displaySignatures && (_enrollmentEntityData?.['field_representative_signature']?.[0]?.['url'] || entityData?.field_representative_signature?.url)"
                 class="img-fluid" style="max-height:28px;"
                 [src]="_enrollmentEntityData?.['field_representative_signature']?.[0]?.['url'] || entityData?.field_representative_signature?.url" />
          </div>
          <small class="text-muted">Teacher's signature</small>
        </div>
        <div class="mb-3">
          <p class="fw-bold mb-0">DATED: <span>{{ (this.entityData?.['field_sale_date']?.value || this.entityData?.['field_sale_date']) | date }}</span></p>
        </div>
        <div>
          <p class="fw-bold mb-0">VERIFIED:</p>
          <div class="border-bottom" style="height:30px;"></div>
          <small class="text-muted">Studio Executive</small>
        </div>
      </div>
    </div>

  </div>
</div>
